import Vue from 'vue';

export default (app, moduleName, moduleComponents) => Object.keys(moduleComponents).reduce((list, name) => {
    Vue.component(name, moduleComponents[name]);
    list.push(name);

    return list;
}, []);
